import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const testimonials = [
  {
    img: "/assets/testimonial1.jpg",
    text: "IanInterios transformed my living space with their beautiful and affordable furniture. The 5% cashback was a delightful bonus!",
    name: "Alphine Mongare",
    role: "Real Estate Agent",
  },

  {
    img: "/assets/testimonial2.jpg",
    text: "Exceptional quality and service! The furniture is stunning, and the 30-day payment terms made it incredibly convenient.",
    name: "Virginia Waringa",
    role: "Interior Designer",
  },
  {
    img: "/assets/testimonial3.jpg",
    text: "The 30-day terms made it easy for us to furnish our new home without financial stress. Highly recommended!",
    name: "Redemption Mshindi",
    role: "Entrepreneur",
  },  {
    img: "/assets/testimonial4.jpg",
    text: "IanInterios transformed my living space with their beautiful and affordable furniture. The 5% cashback was a delightful bonus!",
    name: "Neema Gatobu",
    role: "Real Estate Agent",
  }
];

const TestimonialSlider = () => {
  return (
    <section className="section__container client__container">
      <div className="client__content">
        <h2 className="section__header">What our happy clients say</h2>
        <p className="section__description">
          Testimonials Highlighting Our Commitment to Quality, Exceptional Service, and Customer Satisfaction
        </p>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="client__card">
                <img src={testimonial.img} alt={testimonial.name} />
                <div>
                  <p>{testimonial.text}</p>
                  <h4>{testimonial.name}</h4>
                  <h5>{testimonial.role}</h5>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSlider;
